// extracted by mini-css-extract-plugin
module.exports = {"Page":"Policy_Page__3mlSk"};